export const TECHNICIAN_ROLES = [
  {
    id: 0,
    icon: 'mdi-account-cog',
    position: 'Technicien en charge',
    shortposition: 'DI',
    type: 'techInCharge',
  },
  {
    id: 1,
    icon: 'mdi-account-star',
    position: 'Technicien de recours',
    shortposition: 'REC',
    type: 'mntRecourseTech',
  },
  {
    id: 2,
    icon: 'mdi-worker',
    position: 'Responsable maintenance',
    shortposition: 'RM',
    type: 'mntResponsibleTech',
  },
  {
    id: 3,
    icon: 'mdi-account-convert',
    position: 'Binôme',
    shortposition: 'BIN',
    type: 'mntResponsibleTechBuddy',
  },
  {
    id: 4,
    icon: 'mdi-cowboy',
    multiple: true,
    position: 'Astreinte',
    shortposition: 'AST',
    type: 'onCallTechs',
  },
  {
    id: 5,
    icon: 'mdi-cowboy',
    multiple: true,
    position: 'FIN Astreinte',
    shortposition: 'FAST',
    type: 'onCallEndTechs',
  },
  {
    id: 6,
    icon: 'mdi-account',
    position: 'Technicien',
  },
];

export function getAllPositions(id, specialTechnicians) {
  const astr = specialTechnicians.onCallTechs.find((tech) => tech.id === id);
  const astrEnd = specialTechnicians.onCallEndTechs.find(
    (tech) => tech.id === id
  );
  const specialTechniciansIds = [
    specialTechnicians.techInCharge.id,
    specialTechnicians.mntRecourseTech.id,
    specialTechnicians.mntResponsibleTech.id,
    specialTechnicians.mntResponsibleTechBuddy.id,
    astr ? astr.id : 0,
    astrEnd ? astrEnd.id : 0,
    id,
  ];
  return TECHNICIAN_ROLES.map((item, index) => ({
    ...item,
    techId: specialTechniciansIds[index],
  }));
}

export default function getPosition(id, specialTechnicians) {
  return getAllPositions(id, specialTechnicians).find(
    (item) => id === item.techId
  );
}

export function getPositions(id, specialTechnicians) {
  const roles = getAllPositions(id, specialTechnicians).filter(
    (item) => id === item.techId
  );
  if (roles.length > 1) roles.pop();
  return roles;
}
